import { Header as SemanticHeader } from 'semantic-ui-react';

export { HeaderProps, StrictHeaderProps } from 'semantic-ui-react';

export const Header: typeof SemanticHeader = SemanticHeader;

export default Header;
